import script from "./LoaderAnim.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderAnim.vue?vue&type=script&setup=true&lang=js"

import "./LoaderAnim.vue?vue&type=style&index=0&id=605d6ba3&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605d6ba3"]])

export default __exports__